import moment = require("moment-timezone");
import * as React from "react";
import {RangedDatePickerWithOptionsOptions} from "../../../../components/rangeddatepicker/RangedDatePickerWithOptions";
import {FilterConfig} from "../AlarmsFilter";
import {LegacyChipButtonColor} from "../../../../components/buttons/LegacyChipButton";
import {Display} from "../../../../components/Display";
import {themeDefaultValues} from "../../../../index";

export const ColorPalette = Object.freeze({
    veboxRed: "var(--danfoss-deep-red)",
    gray: "var(--grey-60)",
    text: "black",
});

export const borderRadius = "5px";

export const getChipColor = (disabled: boolean, checked: boolean): LegacyChipButtonColor => {
    /*return {
        background: {
            checked: disabled
                ? "white"
                : ColorPalette.lightBlue,
            default: disabled
                ? "white"
                : ColorPalette.lightBlue,
            onHover: ColorPalette.darkBlue,
        },
        border: disabled
            ? "white"
            : ColorPalette.lightBlue,
        text: {
            default: "rgba(255,255,255,.5)",
            checked: "white",
        },
    };*/
    return {
        background: {
            checked: disabled
                ? "white"
                : themeDefaultValues.buttonBg,
            default: disabled
                ? "white"
                : "transparent",
            onHover: "#cecece",
        },
        border: disabled
            ? "white"
            : themeDefaultValues.buttonBg,
        text: {
            default: "var(--second-level-tabbar-text-color)",
            checked: themeDefaultValues.buttonTextColor,
        },
    };
};

export const getLegacyChipColor = (disabled: boolean, checked: boolean): LegacyChipButtonColor => {
    return {
        background: {
            checked: "var(--grey-60)",
            default: "var(--grey-40)", // "#e3e3e3"// "rgb(239 239 239)",
            onHover: "var(--grey-60)",
        },
        border: "transparent",
        text: {
            default: "var(--black)",
            checked: "var(--black)",
        },
    };
};

export const renderCheckBox = (checked: boolean, disabled: boolean, color) => {
    return (
        <>
            <Display isVisible={checked && !disabled}>
                <div
                    className={"circle"}
                    style={{
                        padding: "2px",
                        boxSizing: "border-box",
                        position: "relative",
                    }}
                >
                    <div
                        style={{
                            position: "absolute",
                            top: "-10px",
                            right: "-10px",
                            width: "15px",
                            height: "15px",
                            borderRadius: "50%",
                            backgroundColor: color,
                            padding: "2px",
                            filter: "brightness(1.3)",
                        }}
                    >
                        <img
                            className={"thumbnail-image"}
                            src={"./images/buttons/icon-apply.png"}
                        />
                    </div>
                </div>
            </Display>
            <Display isVisible={!(checked && !disabled)}>
                <div
                    className={"circle"}
                    style={{
                        padding: "2px",
                        boxSizing: "border-box",
                        position: "relative",
                    }}
                >
                    <div
                        style={{
                            position: "absolute",
                            top: "-10px",
                            right: "-10px",
                            width: "15px",
                            height: "15px",
                            borderRadius: "50%",
                            backgroundColor: "white",
                            padding: "2px",
                            color: "black",
                            textAlign: "center",
                        }}
                    >
                        ✖
                    </div>
                </div>
            </Display>
        </>
    );
};

export interface SpecificAlarmFilterProps {
    disabled: boolean;
    filter: FilterConfig;
    onFilterConfigChanged: (newFilter: FilterConfig) => void;
    resetter?: any;
    selectionOptions?: RangedDatePickerWithOptionsOptions[];
    defaultOption?: any;
}

// TODO: Add to utils
export const copyObj = (obj) => {
    if (obj) {
        return JSON.parse(JSON.stringify(obj));
    }
};

export const toTimezone = (date: Date, timezone): Date => {
    return timezone
        ? moment.tz(
            moment(date === null ? undefined : date)
                .format()
                .slice(0, 19),
            timezone,
        ).toDate()
        : date;
};

export const selectionOptionsFromTimezone = (timezone, texts) => [
    {
        optionName: texts.allOptionLabel,
        optionRange: {
            start: undefined,
            end: undefined,
        },
    },
    {
        optionName: texts.todayOptionLabel,
        optionRange: {
            start:  toTimezone(moment().startOf("day").toDate(), timezone),
            end: undefined,
        },
    },
    {
        optionName: texts.lastWeekOptionLabel,
        optionRange: {
            start: toTimezone(moment().add(-7, "day").startOf("day").toDate(), timezone),
            end: undefined,
        },
    },
    {
        optionName: texts.lastMonthOptionLabel,
        optionRange: {
            start: toTimezone(moment().add(-1, "month").startOf("day").toDate(), timezone),
            end: undefined,
        },
    },
];
